(() => {
  const videos = document.querySelectorAll('video[data-elite-autoplay]');
  if (!videos.length) return;
  const reduceMotion = matchMedia('(prefers-reduced-motion: reduce)');
  const hydrate = video => {
    if (video.dataset.eliteHydrated) return;
    video.querySelectorAll('source[data-src]').forEach(source => {
      source.src = source.dataset.src;
      source.removeAttribute('data-src');
    });
    if (video.dataset.src) {
      video.src = video.dataset.src;
      video.removeAttribute('data-src');
    }
    video.dataset.eliteHydrated = 'true';
    video.load();
  };
  const playVisible = video => {
    if (reduceMotion.matches) return;
    video.play().catch(() => {});
  };
  videos.forEach(video => { video.controls = true; });
  if (!('IntersectionObserver' in window)) {
    videos.forEach(hydrate);
    return;
  }
  const loadObserver = new IntersectionObserver(entries => {
    entries.forEach(entry => {
      if (!entry.isIntersecting) return;
      hydrate(entry.target);
      loadObserver.unobserve(entry.target);
    });
  }, { rootMargin: '200px 0px' });
  const playObserver = new IntersectionObserver(entries => {
    entries.forEach(entry => {
      const video = entry.target;
      if (entry.isIntersecting) {
        hydrate(video);
        playVisible(video);
      } else {
        video.pause();
      }
    });
  }, { threshold: 0.1 });
  videos.forEach(video => {
    loadObserver.observe(video);
    playObserver.observe(video);
  });
})();
